import { backendUrl } from "../../config/api";
import { API_METHOD_GET, API_METHOD_POST } from "../../config/constants";
import {
  getApiBody,
  getApiHeader,
  queryBuilder,
} from "../../helper/apiActionHelper";
import {
  FORBIDDEN_ACTION,
  NEW_USER_CREATED,
  UNAUTHORIZED_USER,
  VERIFICATION_REQUIRED,
} from "../types/authTypes";
import { DOWNLOAD_INVOICE_SUCCESS } from "../types/billTypes";
import {
  COMMON_LOADING_RESET,
  COMMON_LOADING_SET,
  SET_COMMON_REDUCER,
} from "../types/commonTypes";
import {
  TABLE_DATA_FETCH_ERROR,
  TABLE_DATA_FETCH_SUCCESS,
  TABLE_DATA_LOADING,
} from "../types/dtType";

export const api_request = (
  method,
  path,
  body,
  query,
  loadType,
  successType,
  errorType,
  authorized,
  isFile,
  loading = false,
  defError = false,
) => {
  return (dispatch) => {
    if (!loadType || loading) dispatch({ type: COMMON_LOADING_SET });
    else if (loadType?.includes("dt#")) {
      dispatch({
        type: TABLE_DATA_LOADING,
        id: loadType.split("#")[1],
        limit: query.limit,
        offset: query.offset,
      });
    } else dispatch({ type: loadType });

    const headers = getApiHeader(method, authorized, isFile);
    const apiBody = getApiBody(method, body, isFile);
    console.log(
      "api_request called with params:",
      apiBody,
      headers,
      method,
      path,
      query,
      loadType,
      successType,
      errorType,
      authorized,
      isFile,
      loading,
    );
    fetch(backendUrl + queryBuilder(path, query), {
      method: method,
      headers: headers,
      body: apiBody,
    })
      .then((response) =>
        response.json().then((data) => {
          if (!loadType || loading) dispatch({ type: COMMON_LOADING_RESET });

          if (response.status === 200) {
            if (Array.isArray(successType)) {
              for (let i = 0; i < successType?.length; i++) {
                if (successType[i].includes("dt#")) {
                  dispatch({
                    type: TABLE_DATA_FETCH_SUCCESS,
                    payload: data?.data ? data.data : data,
                    limit: query.limit,
                    offset: query.offset,
                    id: successType[i].split("#")[1],
                    message: data.message,
                  });
                } else {
                  dispatch({
                    type: successType[i],
                    payload: data?.data ? data.data : data,
                    message: data.message,
                  });
                }
              }
            } else {
              dispatch({
                type: successType,
                payload: data?.data ? data.data : data,
                message: data.message,
              });
            }
          } else if (response.status === 201) {
            dispatch({
              type: VERIFICATION_REQUIRED,
              payload: data?.data ? data.data : data,
              message: data.message,
            });
          } else if (response.status === 401 && authorized) {
            dispatch({ type: UNAUTHORIZED_USER, message: data.message });
          } else if (response.status === 403 && authorized) {
            dispatch({ type: FORBIDDEN_ACTION, message: data.message });
          } else {
            if (defError && data.message) {
              console.error("Error in api_request: ", data);
              alert(data.message);
            }
            if (Array.isArray(errorType)) {
              for (let i = 0; i < errorType?.length; i++) {
                if (errorType[i].includes("dt#")) {
                  dispatch({
                    type: TABLE_DATA_FETCH_ERROR,
                    id: errorType[i].split("#")[1],
                    message: data.message,
                  });
                } else {
                  dispatch({
                    type: errorType[i],
                    message: data.message,
                  });
                }
              }
            } else {
              dispatch({
                type: errorType,
                message: data.message,
              });
            }
          }
        }),
      )
      .catch((err) => {
        if (!loadType || loading) dispatch({ type: COMMON_LOADING_RESET });
        console.error(err);
        if (Array.isArray(errorType)) {
          for (let i = 0; i < errorType?.length; i++) {
            if (errorType[i].includes("dt#")) {
              dispatch({
                type: TABLE_DATA_FETCH_ERROR,
                id: errorType[i].split("#")[1],
                message: "Internal error",
              });
            } else {
              dispatch({
                type: errorType[i],
                message: "Internal error",
              });
            }
          }
        } else {
          dispatch({
            type: errorType,
            message: "Internal error",
          });
        }
      });
  };
};

export const setCommonReducer = (data) => {
  return (dispatch) => {
    dispatch({ type: SET_COMMON_REDUCER, payload: data });
  };
};

export const downloadExcel = (
  query,
  path = "/docs/export",
  method = API_METHOD_GET,
  body = null,
) => {
  return (dispatch) => {
    dispatch({
      type: COMMON_LOADING_SET,
    });

    const filename = query.fileName || "data.xlsx";
    delete query.fileName;
    var newUrl = queryBuilder(path, query);
    fetch(
      backendUrl + newUrl,
      method !== API_METHOD_GET && body
        ? {
            method: method,
            headers: getApiHeader(method, true, false),
            body: JSON.stringify(body),
          }
        : {
            method: method,
            headers: getApiHeader(method, true, false),
          },
    )
      .then((response) => {
        dispatch({
          type: COMMON_LOADING_RESET,
        });
        if (response.status === 500) {
          console.error("ERROR in blob");
          response
            .json()
            .then((data) => {
              alert(data?.message || "Internal Error");
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message || "Internal Error");
            });
        } else if (response.status === 401) {
          dispatch({
            type: UNAUTHORIZED_USER,
          });
        } else if (response.status === 403) {
          dispatch({
            type: FORBIDDEN_ACTION,
          });
        } else if (response.status === 200) {
          response
            .blob()
            .then((blob) => {
              const data = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = data;
              link.download = filename;
              link.click();
              setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 100);
              dispatch({
                type: DOWNLOAD_INVOICE_SUCCESS,
              });
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 201) {
          response
            .json()
            .then((data) => {
              dispatch({
                type: DOWNLOAD_INVOICE_SUCCESS,
              });
              alert(data?.message || "Will be available shortly");
            })
            .catch((err) => {
              alert("File download error");
            });
        } else {
          console.error("ERROR in blob");
          alert("File download error");
        }
      })
      .catch((err) => {
        console.error("ERROR in catch", err);
        alert(err?.message);
      });
  };
};

export const downloadTemplate = (query) => {
  return (dispatch) => {
    dispatch({
      type: COMMON_LOADING_SET,
    });
    const filename = "template.xlsx";

    var newUrl = "/ledger/template";
    fetch(backendUrl + newUrl, {
      method: API_METHOD_GET,
      headers: getApiHeader(API_METHOD_GET, true, false),
    })
      .then((response) => {
        dispatch({
          type: COMMON_LOADING_RESET,
        });
        if (response.status === 500) {
          console.error("ERROR in blob");
          response
            .json()
            .then((data) => {
              alert(data?.message || "Internal Error");
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message || "Internal Error");
            });
        } else if (response.status === 401) {
          dispatch({
            type: UNAUTHORIZED_USER,
          });
        } else if (response.status === 403) {
          dispatch({
            type: FORBIDDEN_ACTION,
          });
        } else if (response.status === 200) {
          response
            .blob()
            .then((blob) => {
              const data = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = data;
              link.download = filename;
              link.click();
              setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 100);
              dispatch({
                type: DOWNLOAD_INVOICE_SUCCESS,
              });
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else {
          console.error("ERROR in blob");
          alert("File download error");
        }
      })
      .catch((err) => {
        dispatch({
          type: COMMON_LOADING_RESET,
        });
        alert("File download error");
        console.error("ERROR in catch", err);
        alert(err?.message);
      });
  };
};

export const downloadFileCommon = ({ fileName, query = {}, body, path }) => {
  console.log("downloadFileCommon called with params:", {
    fileName,
    query,
    body,
    path,
  });
  return (dispatch) => {
    dispatch({
      type: COMMON_LOADING_SET,
    });

    fetch(queryBuilder(backendUrl + path, query), {
      method: API_METHOD_POST,
      headers: getApiHeader(API_METHOD_POST, true, false),
      body: JSON.stringify(body),
    })
      .then((response) => {
        dispatch({
          type: COMMON_LOADING_RESET,
        });
        if (response.status === 500) {
          console.error("ERROR in blob");
          response
            .json()
            .then((data) => {
              alert(data?.message || "Internal Error");
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message || "Internal Error");
            });
        } else if (response.status === 401) {
          dispatch({
            type: UNAUTHORIZED_USER,
          });
        } else if (response.status === 403) {
          dispatch({
            type: FORBIDDEN_ACTION,
          });
        } else if (response.status === 200) {
          response
            .blob()
            .then((blob) => {
              const data = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = data;
              link.download = fileName;
              link.click();
              setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 100);
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else {
          console.error("ERROR in blob");
          alert("File download error");
        }
      })
      .catch((err) => {
        dispatch({
          type: COMMON_LOADING_RESET,
        });
        alert("File download error");
        console.error("ERROR in catch", err);
        alert(err?.message);
      });
  };
};
